var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper",class:{ loading: _vm.loading },attrs:{"id":"mindMapping"},on:{"click":function($event){return _vm.$emit('previewAllImages')}}})}
var staticRenderFns = []

export { render, staticRenderFns }